import type { LapSegment } from "../fit/laps";
import type { Units } from "../units";
import {
  formatClock,
  formatDistance,
  formatDuration,
  formatElevation,
  formatSpeed,
} from "../units";

interface Props {
  segments: LapSegment[];
  units: Units;
  highlightLap: number | null;
  onHoverLap: (lap: number | null) => void;
  onFocusLap: (lap: number) => void;
  onRemoveSplitAt: (pos: number) => void;
}

export default function LapTable({
  segments,
  units,
  highlightLap,
  onHoverLap,
  onFocusLap,
  onRemoveSplitAt,
}: Props) {
  return (
    <div className="lap-table-wrap">
      <table className="lap-table">
        <thead>
          <tr>
            <th>Lap</th>
            <th>Start</th>
            <th>Duration</th>
            <th>Distance</th>
            <th>Avg speed</th>
            <th>Avg power</th>
            <th>Avg HR</th>
            <th>Ascent</th>
            <th aria-label="actions" />
          </tr>
        </thead>
        <tbody onMouseLeave={() => onHoverLap(null)}>
          {segments.map((seg) => {
            // The boundary that ends this lap is split position seg.index
            // (present for every lap except the last).
            const boundaryPos = seg.index;
            const isLast = seg.index === segments.length - 1;
            return (
              <tr
                key={seg.index}
                className={`lap-row${highlightLap === seg.index ? " hl" : ""}`}
                onMouseEnter={() => onHoverLap(seg.index)}
                onClick={() => onFocusLap(seg.index)}
                title="Click to zoom the map to this lap"
              >
                <td className="lap-num">{seg.index + 1}</td>
                <td>{formatClock(seg.startTime)}</td>
                <td>{formatDuration(seg.durationSec)}</td>
                <td>{formatDistance(seg.distanceM, units)}</td>
                <td>{formatSpeed(seg.avgSpeed, units)}</td>
                <td>
                  {seg.avgPower !== null ? `${Math.round(seg.avgPower)} W` : "—"}
                </td>
                <td>
                  {seg.avgHeartRate !== null
                    ? `${Math.round(seg.avgHeartRate)} bpm`
                    : "—"}
                </td>
                <td>{formatElevation(seg.ascentM, units)}</td>
                <td className="lap-action">
                  {!isLast && (
                    <button
                      className="merge-btn"
                      title="Remove this boundary (merge with the next lap)"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveSplitAt(boundaryPos);
                      }}
                    >
                      merge ↓
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
